import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-mat-dialog',
    templateUrl: './mat-dialog.component.html',
    styleUrls: ['./mat-dialog.component.scss'],
    standalone: false
})
export class MatDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<MatDialogComponent>
  ) {
  }
  closeDialog() {
    this.dialogRef.close(false);
  }

  ngOnInit() {
  }

}
